import { render } from "./BigIconsSection.vue?vue&type=template&id=1966fc9b"
import script from "./BigIconsSection.vue?vue&type=script&lang=js"
export * from "./BigIconsSection.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/jwbpinellas/wp-content/themes/jwb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__